import React from 'react';
import { Navigate } from 'react-router-dom';

// "/" is where older home-screen installs open (iOS bakes start_url at install time).
// Signed-in members go into the app; the installed app sends signed-out members to
// the member login; plain browser visitors see the sales page.
const isInstalledApp = () =>
  window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone === true;

const LandingPage = () => {
  const hasToken = !!localStorage.getItem('rxgrit_token');
  if (hasToken) return <Navigate to="/my-actions" replace />;
  return <Navigate to={isInstalledApp() ? '/login' : '/signup'} replace />;
};

export default LandingPage;
